import React, { useEffect, useState } from 'react';
import chatApp from '../assets/chatapp.png';
import ebookApp from '../assets/ebookapp.png';
import todoList from '../assets/todolist.png';
import dailyHadith from '../assets/dailyhadith.png';
import easyVoting from '../assets/easyvoting.png';
import claimx from '../assets/claimx.png';
import toys4joy from '../assets/toys4joy.png';
import { Colors } from '../constants/Colors';
import ProjectDetails from '../components/Project_Details';

function Projects({ mode }) {
    const { background } = Colors(mode);
    const [selectedProject, setSelectedProject] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [hoveredProject, setHoveredProject] = useState(null);

    const project = [
        {
            projectImage: '/assets/cvpilotai/cv pilot thumb.png',
            projectTitle: 'CVPilot AI',
            category: 'Mobile App / AI',
            techUsed: 'Flutter, FastAPI, Gemini API, Firebase',
            keyFeatures:
                '• AI resume analysis and career recommendations\n• Dynamic content generators for cover letters and profiles\n• FastAPI backend with JWT auth and database storage\n• Flutter frontend with responsive mobile UI',
            description:
                'CVPilot AI is an intelligent career assistant built with Flutter, FastAPI, Gemini API, and Firebase. It analyzes resumes, generates career-ready content, and guides users through personalized job preparation workflows.',
            link: 'https://github.com/BasharatSahito/CVPilot-AI',
            demoScreenshots: [
                '/assets/cvpilotai/cv pilot thumb.png',
                '/assets/cvpilotai/CVPilotAI Homepage.jpg',
                '/assets/cvpilotai/cvpilotai second.jpg'] // Reference placeholders
        },
        {
            projectImage: chatApp,
            projectTitle: 'Chat Application',
            category: 'Mobile App',
            techUsed: 'Flutter, Firebase, Firestore, ZegoCloud',
            keyFeatures:
                '• Google Account Authentication\n• Contact discovery with email lookup\n• Real-time chat with Firestore sync\n• Integrated ZegoCloud video calling',
            description:
                'Built a real-time chat application enabling secure messaging, contact management, and video calling using ZegoCloud, showing advanced integration of communication features in a mobile experience.',
            link: 'https://github.com/BasharatSahito/Flutter-Chat-App-with-Firebase',
            demoScreenshots: [chatApp, chatApp, chatApp]
        },
        {
            projectImage: ebookApp,
            projectTitle: 'E-Book Library App',
            category: 'Mobile App',
            techUsed: 'Flutter, Provider, Google Books API, Offline PDF support',
            keyFeatures:
                '• Dynamic book discovery with REST API\n• Offline PDF reading support\n• Saved bookmarks and library management\n• Provider state management for smooth UX',
            description:
                'A feature-rich eBook library app that integrates the Google Books API for dynamic content, offline PDF reading, and bookmark management.',
            link: 'https://github.com/BasharatSahito/Ebooks-library-with-Google-Books-Api',
            demoScreenshots: [ebookApp, ebookApp, ebookApp]
        },
        {
            projectImage: easyVoting,
            projectTitle: 'Easy Voting App',
            category: 'Mobile App / Security',
            techUsed: 'Flutter, Firebase, Firestore, Biometric auth',
            keyFeatures:
                '• Multi-factor voting security\n• Admin dashboard for election management\n• Real-time vote aggregation\n• Secure user voting with live results',
            description:
                'A secure voting application developed for real-world election scenarios using Flutter and Firebase to deliver multi-factor authentication and real-time result tracking.',
            link: 'https://github.com/BasharatSahito/Easy-Voting-App',
            demoScreenshots: [easyVoting, easyVoting, easyVoting]
        },
        {
            projectImage: dailyHadith,
            projectTitle: 'Daily Hadith App',
            category: 'Mobile App',
            techUsed: 'Flutter, Local Notifications, Offline Storage',
            keyFeatures:
                '• Daily Hadith delivery with scheduled notifications\n• Offline access to saved content\n• Lightweight, engaging reading experience',
            description:
                'A devotional app built to deliver daily Hadith messages with scheduled offline notifications, focusing on a calm interface and reliable background scheduling.',
            link: 'https://github.com/BasharatSahito/Daily-Hadith-App',
            demoScreenshots: [dailyHadith, dailyHadith, dailyHadith]
        },
        {
            projectImage: todoList,
            projectTitle: 'TO DO List App',
            category: 'Mobile App',
            techUsed: 'Flutter, Hive, Provider, Shared Preferences',
            keyFeatures:
                '• Add, edit, and delete tasks\n• Offline local storage with Hive\n• Persistent preferences and task states',
            description:
                'A productive task management app that leverages Hive and Shared Preferences for offline persistence, along with Provider for responsive state changes.',
            link: 'https://github.com/BasharatSahito/Todo-List-App',
            demoScreenshots: [todoList, todoList, todoList]
        },
        {
            projectImage: claimx,
            projectTitle: 'ClaimX',
            category: 'Mobile App',
            techUsed: 'Flutter, Firebase, Firestore, ZegoCloud',
            keyFeatures:
                '• Secure user sessions with Firebase auth\n• Realtime Firestore data sync\n• Multimedia features via ZegoCloud',
            description:
                'ClaimX is a modern Flutter application built with Firebase and Firestore, integrating ZegoCloud to support collaborative audio/video features.',
            link: 'https://claimx.org',
            demoScreenshots: [claimx, claimx, claimx]
        },
        {
            projectImage: toys4joy,
            projectTitle: 'Toys4Joy',
            category: 'E-Commerce App',
            techUsed: 'Flutter, Firebase, Firestore, ZegoCloud',
            keyFeatures:
                '• E-commerce style listing and discovery\n• Realtime data with Firestore\n• Enhanced communication using ZegoCloud',
            description:
                'A playful app focused on product discovery and real-time interactions, combining mobile e-commerce design with live communication capabilities.',
            link: 'https://toys4joy.com',
            demoScreenshots: [toys4joy, toys4joy, toys4joy]
        },
    ];

    useEffect(() => {
        const body = document.body;
        if (isModalOpen) {
            body.classList.add('modal-open');
        } else {
            body.classList.remove('modal-open');
        }
        return () => body.classList.remove('modal-open');
    }, [isModalOpen]);

    const handleOpenModal = (item) => {
        setSelectedProject(item);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setSelectedProject(null);
        setIsModalOpen(false);
    };

    return (
        <div className={`${background} py-5`}>
            <div className="container">
                <div className="section-heading mb-5">
                    <p className="section-title">Featured Projects</p>
                    <p className="section-subtitle">
                        Hover over a project to preview it, or click to view detailed architecture and screenshots.
                    </p>
                </div>

                {/* Vertical Project List Container */}
                <div className="project-vertical-list">
                    {project.map((item, index) => (
                        <div
                            key={index}
                            className="project-list-row"
                            onMouseEnter={() => setHoveredProject(index)}
                            onMouseLeave={() => setHoveredProject(null)}
                            onClick={() => handleOpenModal(item)}
                        >
                            {/* Left Side: Index, Title, Tech Stack */}
                            <div className="project-row-left">
                                <span className="project-index">0{index + 1}</span>
                                <div className="project-title-group">
                                    <h3 className="project-row-title">{item.projectTitle}</h3>
                                    <p className="project-row-tech-text">{item.techUsed}</p>
                                </div>
                            </div>

                            {/* Right Side: Category Badge, Arrow, & Dedicated Image Container */}
                            <div className="project-row-right">
                                <span className="project-row-category">{item.category}</span>

                                <div className="project-arrow-btn">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="7" y1="17" x2="17" y2="7"></line>
                                        <polyline points="7 7 17 7 17 17"></polyline>
                                    </svg>
                                </div>

                                {/* Dedicated Slot for Hover Image at the far right */}
                                <div className="project-preview-slot">
                                    {hoveredProject === index && (
                                        <div className="project-hover-preview">
                                            <img src={item.projectImage} alt={item.projectTitle} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {isModalOpen && <ProjectDetails project={selectedProject} onClose={handleCloseModal} />}
        </div>
    );
}

export default Projects;